export default __webpack_public_path__ + "static/media/floor-12.a82dcc13.jpg";